var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-ad-list" },
    [
      _c(
        "el-select",
        {
          class: [
            "wl-ad-select",
            _vm.showAdd ? "has-right-btn" : "no-right-btn",
            _vm.size === "mini" ? "mini" : "small",
          ],
          attrs: {
            value: _vm.myValue,
            filterable: "",
            multiple: _vm.multi,
            remote: "",
            "collapse-tags": _vm.collapseTags,
            "reserve-keyword": "",
            clearable: "",
            placeholder: _vm.$t("TABLE_HEADER_EMAIL_StaffName"),
            "remote-method": _vm.callStack,
            loading: _vm.loading,
            disabled: _vm.selectDisabled,
          },
          on: { change: _vm.onValueChange, clear: _vm.onClear },
        },
        _vm._l(_vm.options, function (item, k) {
          return _c("el-option", {
            key: k,
            attrs: { label: item.label, value: item.email },
          })
        }),
        1
      ),
      _vm.showAdd
        ? _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { icon: "el-icon-plus", disabled: _vm.disabled },
              on: { click: _vm.addAccount },
            },
            [_vm._v(_vm._s(_vm.$t("COMMON_ADD")) + "\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }